import {  CheckCircleTwoTone, ClockCircleFilled, ClockCircleTwoTone, EnterOutlined, QrcodeOutlined, RightCircleFilled, RightCircleOutlined, SearchOutlined, SettingOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import { Alert, Badge, Button, Card, Input, Progress, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import TableLZM from '../../../components/design/table/TableLZM';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { LocationCardCompacted } from '../../../components/model/business/FieldsGroup';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { useHistory } from 'react-router-dom';
import { SpinLZ } from '../../../components/design/Spinner/SpinLZ';
import { ColorStarOutlined } from '../../../../common/utils/ColorStar';
import { useIsAuthorized } from '../../common/roles/Roles';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import SelectPeriod from '../../../components/model/selectMonths/SelectPeriod';
import { GlobalVariableContext } from '../../../../store/GlobalVariableContext/GlobalVariableContext';
import { QRDrawer } from '../qr/QRDrawer';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';

export const LocationsReviews = () => {

	const { setReviewsDrawer } = useContext(DrawerContext);
	const { setLocationDrawer, setConfigureIADrawer, setConfigureIAByLocalDrawer } = useContext(DrawerContext)
	const [isLoading, setIsLoading] = useState(true);
	
	const history = useHistory();
	
	const [reviewsData, setReviewsData] = useState([]);
	//const [localIAConfig, setLocalIAConfig] = useState([]);
	const [reviewsKpis, setReviewsKpis] = useState();
	const [totalNumberOfPendingReviews, setTotalNumberOfPendingReviews] = useState(null);
	const [refreshReviews, setRefreshReviews] = useState(false);
	const { projectGroup, getGroupName } = useAuth();		
	const [filterReference, setFilterReference] = useState('periodOpt=LAST_30DAYS');
	const [range, setRange] = useState('LAST_30DAYS');
	const isAuthorized = useIsAuthorized();
	const {updateGlobalData, setUpdateGlobalData } = useContext(GlobalVariableContext);
	const [locationQRDrawer, setLocationQRDrawer] = useState<any>(null);
	const { t } = useTranslation();
	
	const onRangeChange = (range: any) => {      
		
		setRange(range);
        setFilterReference('periodOpt=' + range);		
    };

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations/reviews?${filterReference}`, {}, [refreshReviews, updateGlobalData], 	
	(data) => { 
		setIsLoading(true);
		//setLocalIAConfig(data.localIAConfig);
		setReviewsKpis(data.reviewsKPIs);	
		setReviewsData(data.locationsWithReviewsList);	
		setTotalNumberOfPendingReviews(data.totalNumberOfPendingReviews);
		setIsLoading(false);
	});	

	const columns: any = [		
		{
			title: '',
			key: 'composeId',						
			align: 'center',
			sorter: (a: any, b: any) => b.reviewsKPIs?.rateAvgNew - a.reviewsKPIs?.rateAvgNew,
			width: '100px',			
			render: (text: string, record: any) => (record.reviewsKPIs?.numberOfReviews > 0 &&
                <>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<ColorStarOutlined
							style={{ fontSize: '18px' }}
							value={Math.round(10 * record.reviewsKPIs.rateAvg) / 10}/>						
					</div>
					<small style={{ color: '#94a3b8' }}>{record.reviewsKPIs.numberOfReviews} reseñas</small>
				</>)			
		},
		{
			title: 'Establecimiento',
			key: 'location',			
			width: '350px',						
			sorter: (a: any, b: any) => a.locality?.localeCompare(b.locality),
			filterDropdown: ({
			  setSelectedKeys,
			  selectedKeys,
			  confirm,			  
			}: FilterDropdownProps) => {
			  return (
				<Input
				  autoFocus
				  //placeholder="Filtro"
				  value={selectedKeys[0]}
				  onChange={(e: any) => {
					setSelectedKeys(e.target.value ? [e.target.value] : []);
					confirm({ closeDropdown: false });
				  }}
				  onPressEnter={() => {
					confirm();
				  }}
				  onBlur={() => {
					confirm();
				  }}
				></Input>
			  );
			},
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
				return record.title?.toLowerCase().includes(value?.toLowerCase()) 
				|| record.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
				|| record.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (				
				<LocationCardCompacted
					colorSettings={record.localConfig ? 'dodgerblue':'silver'}
					location={record}
					onClick={() => { setConfigureIAByLocalDrawer(record.locationId); }}
					onClickDisabledReason={esTodosLosGrupos
						? 'Debes seleccionar un grupo de Google en la cabecera'
						: undefined}
					onChange={() => { setLocationDrawer(record.composeId); }}
				/>
			),
		},	
		{
			title: 'Automatización',
			key: 'automatedRules',						
			render: (text: string, record: any) => (				
				<div>
					<Progress showInfo={false} percent={10 * record.automatedRules} steps={10} strokeColor={'dodgerblue'} trailColor='lightgrey'/>					
					<div>
						{
						record.automatedRules ?				
						<><Badge status="processing" /><small style={{borderRadius:'5px', color:'SteelBlue'}}>{10 * record.automatedRules}% automatizada</small></>
						:
						<><Badge status="default" /><small style={{borderRadius:'5px', color:'slategrey'}}>Manual</small></>					
						}
					</div>
				</div>
			)
		},		
		{
			title: 'Reseñas Pendientes',
			key: 'recentRepliedRatio',			
			sorter: (a: any, b: any) => b.reviewsKPIs?.numberOfPendingReviews - a.reviewsKPIs?.numberOfPendingReviews,
			align: 'left',
			render: (text: string, record: any) => (
				<>										
					{record.reviewsKPIs?.numberOfPendingReviews > 0 ? 
						<div style={{color:'MediumVioletRed'}}><ClockCircleTwoTone twoToneColor='MediumVioletRed' /> {record.reviewsKPIs?.numberOfPendingReviews} pendientes</div>
						:
						<i style={{color:'lightgrey'}}>No hay pendientes</i>
					}
				</>
			)
		},
		{
			title: '',
			key: 'numberOfReviews',
			dataIndex: 'numberOfReviews',
			width: '250px',
			//align: 'center',			
			render: (text: string, record: any) => (
				<div style={{display:'flex', justifyContent: 'right', gap: '10px'}}>	
					{record.placeId &&
					<ButtonLZ type='primary' onClick={()=>{setLocationQRDrawer({location: record.location, url: `https://search.google.com/local/writereview?placeid=${record.placeId}`})}} size='small' > 
						<div><QrcodeOutlined/> QR</div>							
					</ButtonLZ>					
					}											
					<Badge size='small' dot={record.reviewsKPIs?.numberOfPendingReviews>0} color='MediumVioletRed'>
						<ButtonLZ type='primary' onClick={()=>{setReviewsDrawer({id:record.composeId, range: range})}} size='small' >    						
							<div><StarFilled/> Responder</div>							
						</ButtonLZ>																
					</Badge>
				</div>
				)			
		}		
	]

	const esTodosLosGrupos = getGroupName() === 'Todos los Grupos';
	const tienePermisos = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_REVIEWS']);

  	return (
		<>			
			<Card className='main-card-content'>
			{/*getGroupName()*/}
				<div style={{ marginBottom:'0px' }}>
					<PageTitle
						title='Responder Reseñas'
						pageInfo='Responde reseñas desde esta pantalla si lo que quieres es hacerlo local por local. Responder reseñas será más rápido con las sugerencias de la IA, estas sugerencias se basan por defecto en la información de la propia ficha (nombre, descripción y categoría), pero desde la pantalla de Agente IA puedes añadir todo tipo de personalizaciones, además puedes automatizar las respuestas según la puntuación de la misma y si tienen o no texto.'
						extra={
							esTodosLosGrupos ? (
								<Tooltip
									color='transparent'
									overlayInnerStyle={{ padding: 0, boxShadow: 'none' }}
									title={
										<span style={{
											display: 'inline-block',
											padding: '10px 14px',
											borderRadius: 10,
											background: '#fffbeb',
											border: '1px solid #fcd34d',
											color: '#b45309',
											fontSize: 13,
											fontWeight: 500,
											lineHeight: 1.5,
											maxWidth: 280,
										}}>
											Debes seleccionar un grupo de Google en la cabecera, cada grupo tiene su propia configuración
										</span>
									}
								>
									<span>
										<ButtonLZ
											disabled
											type='dashed'
											style={{
												borderColor: 'slategrey',
												backgroundColor: 'ghostwhite',
												cursor: 'not-allowed',
												transition: 'all 0.3s',
											}}
										>
											<div style={{ color: 'slategrey', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 500 }}>
												<SettingOutlined />
												Responder con IA
											</div>
										</ButtonLZ>
									</span>
								</Tooltip>
							) : (
								<ButtonLZ
									disabled={!tienePermisos}
									type='default'
									onClick={() => { setConfigureIADrawer(true); }}
								>
									<div style={{ color: 'black', display: 'flex', alignItems: 'center', gap: '6px' }}>
										<SettingOutlined />
										Responder con IA
									</div>
								</ButtonLZ>
							)
						}
					/>
					<p style={{marginBottom:'0px'}}>Agrupadas por local</p>
				</div>			
				
                <Synchronized service={[SCHEDULEDJOB.GBP_REVIEWS]}/>	
				
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 12, marginBottom: 4 }}>
					{totalNumberOfPendingReviews != null && (
						<span
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								gap: 8,
								padding: '4px 10px',
								borderRadius: 8,
								fontSize: 13,
								fontWeight: 600,
								lineHeight: 1.2,
								marginBottom: 1,
								...(totalNumberOfPendingReviews > 0
									? {
										color: 'MediumVioletRed',
										background: 'LavenderBlush',
										border: '1px solid #f0c4d0',
									}
									: {
										color: '#389e0d',
										background: '#F3FFFA',
										border: '1px solid #b7eb8f',
									}),
							}}
						>
							{totalNumberOfPendingReviews > 0 ? (
								<>
									<ClockCircleTwoTone twoToneColor='MediumVioletRed' />
									{totalNumberOfPendingReviews} pendientes
								</>
							) : (
								<>
									<CheckCircleTwoTone twoToneColor='#52c41a' />
									No hay pendientes
								</>
							)}
						</span>
					)}
					<PageFilters>
						<PageFilterField label='Periodo'>
							<SelectPeriod setSelectedType={onRangeChange} defaultValue='LAST_30DAYS'/>
						</PageFilterField>
					</PageFilters>
				</div>
				
				{/*<div className="card-container">
					{reviewsKpis && <BlockReviewsKpis reviewsKPIs={reviewsKpis} period={'ALL'} recentPeriod={'LAST_30DAYS'} minMax={true}/>}
				</div>*/}

				{isLoading ? <SpinLZ/> :
					reviewsData &&
						<TableLZM
							rowKey='name'
							scroll={{ x: true, y: 800 }}
							columns={columns}
							dataSource={reviewsData}
							pagination={{ defaultPageSize: 20 }}
							loading={false}/>
				}
				
			</Card>
			{locationQRDrawer && <QRDrawer location={locationQRDrawer.location} url={locationQRDrawer.url} onFinish={() => {setLocationQRDrawer(null);}} />}			
		</>
	)
}
